import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import React from 'react'
import { NightlyLatestEdition } from './LatestEdition/NightlyLatestEdition'

export interface NightlyLatestEditionRouteProps {
    title: string
    type: 'homepage' | 'editions'
    lazyloadImages?: boolean
}

export const NightlyLatestEditionRegistration =
    createRegisterableComponentWithData(
        'nightly-latest-edition',
        EditionLoader,
        (
            { type, title, lazyloadImages }: NightlyLatestEditionRouteProps,
            data,
            services,
        ) => {
            if (!data.loaded) return null

            return (
                <NightlyLatestEdition
                    edition={data.result.documents[0]}
                    title={title}
                    type={type}
                    lazyloadImages={lazyloadImages}
                    onEvent={services.onEvent}
                />
            )
        },
    )
